"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertToOptions = exports.SEGMENT = exports.PRODUCT_INFO_WIDTH = exports.PRODUCT_INFO_HEIGHT = exports.PICTURE_GAP_HEIGHT = exports.FEATURES_COLOR = exports.COMPONENTS = exports.CARD_LAYOUT = exports.BOX_SHADOW = exports.BORDER = exports.BG_COLOR = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.price"));

var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.claim"));

var _gerenciatdUnifiedcomponents6 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));

var _reactImageAndBackgroundImageFade = require("react-image-and-background-image-fade");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _index = _interopRequireDefault(require("./PriceBox/index"));

require("./ProductItem.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
exports.SEGMENT = SEGMENT;
const BG_COLOR = {
  PURPLE: 'purple',
  WHITE: 'white'
};
exports.BG_COLOR = BG_COLOR;
const BORDER = {
  RADIUS: 'radius',
  STRAIGHT: 'straight'
};
exports.BORDER = BORDER;
const BOX_SHADOW = {
  NONE: 'none',
  DEFAULT: 'default-shadow'
};
exports.BOX_SHADOW = BOX_SHADOW;
const COMPONENTS = {
  TEXT_INFO_1: 'TextInfo-1',
  TEXT_INFO_2: 'TextInfo-2',
  TEXT_INFO_3: 'TextInfo-3',
  CLAIM_1: 'Claim-1',
  PRICE_1: 'Price-1',
  PRICE_2: 'Price-2',
  BUTTON_1: 'Button-1',
  PRICE_BOX: 'Price-box',
  PROMO_BOX: 'Promo-box'
};
exports.COMPONENTS = COMPONENTS;
const FEATURES_COLOR = {
  GREY_5: 'grey5',
  EMP_BLUE_DARK: 'emp-dark-blue',
  EMP_MEDIUM_PURPLE: 'emp-medium-purple'
};
exports.FEATURES_COLOR = FEATURES_COLOR;
const PRODUCT_INFO_HEIGHT = {
  DEFAULT: 'default',
  STATIC: 'static'
};
exports.PRODUCT_INFO_HEIGHT = PRODUCT_INFO_HEIGHT;
const PICTURE_GAP_HEIGHT = {
  SHORT: 'short',
  LARGE: 'large'
};
exports.PICTURE_GAP_HEIGHT = PICTURE_GAP_HEIGHT;
const PRODUCT_INFO_WIDTH = {
  DEFAULT: 'default',
  LARGE: 'large'
};
exports.PRODUCT_INFO_WIDTH = PRODUCT_INFO_WIDTH;
const CARD_LAYOUT = {
  DEFAULT: 'default',
  ROUND: 'round'
};
exports.CARD_LAYOUT = CARD_LAYOUT;

const convertToOptions = optionsObject => {
  const keys = Object.keys(optionsObject);
  return keys.map(key => {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;

class ProductItem extends _react.Component {
  constructor(props) {
    super(props);
    const id = (0, _gerenciatdUtils.generateComponentId)('ProductItemSH', '');
    this.state = {
      id,
      hover: false
    };
  }

  render() {
    const {
      id
    } = this.state;
    const {
      bgColor,
      features,
      featureStyles,
      img,
      brandImg,
      components,
      segment,
      productInfoHeight,
      pictureGapHeight,
      layout,
      width
    } = this.props;
    const title = components && components['TextInfo-1'];
    const description = components && components['TextInfo-2'];
    const textoLegal = components && components['TextInfo-3'];
    const secondTitle = components && components['TextInfo-4'];
    const button1 = components && components['Button-1'];
    const button2 = components && components['Button-2'];
    const button3 = components && components['Button-3'];
    const price1 = components && components['Price-1'];
    const price2 = components && components['Price-2'];
    const claim = components && components['Claim-1'];
    const customLink1 = components && components['CustomLink-1'];
    const priceBox = components && components['Price-box'];
    const promoBox = components && components['Promo-box'];
    const layoutClass = `ProductItem__border--${layout} ProductItem__box-shadow--${layout}`;
    const widthClass = `ProductItem--${width}`;
    const bgColorCss1 = ` productInfoGap_bgColor--${bgColor}-${segment}`;
    const bgColorCss2 = ` productInfoGap_content_bgColor--${bgColor}-${segment}`;
    const productItemClass = `ProductItem ${widthClass} ${layoutClass}`;
    const titleClass = !priceBox && title && title.segment === 'emp' ? 'productInfoGap_content_title-margin' : 'title';
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: id,
      className: productItemClass,
      children: [img && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `pictureGap pictureGap--${pictureGapHeight}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageAndBackgroundImageFade.BackgroundImage, {
          src: img,
          width: "800px",
          height: "400px",
          wrapperClassName: "productImg",
          isResponsive: true,
          lazyLoad: true
        }), brandImg && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "brandImg",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, brandImg))
        }), promoBox && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `promo-box promo-box--img promo-box_bgColor--${promoBox.bgColor || 'purple'}-${segment}`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, promoBox.TextInfo), {}, {
            segment: segment
          }))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `productInfoGap productInfoGap_height--${productInfoHeight} ${bgColorCss1}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `productInfoGap_content ${bgColorCss2}`,
          children: [promoBox && !img && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `promo-box promo-box_bgColor--${promoBox.bgColor || 'purple'}-${segment}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, promoBox.TextInfo), {}, {
              segment: segment
            }))
          }), brandImg && !img && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "brandImg",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, brandImg))
          }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, title), {}, {
            className: titleClass,
            segment: segment
          })), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, description), {}, {
            segment: segment
          })), priceBox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default, _objectSpread(_objectSpread({}, priceBox), {}, {
            segment: segment
          })), textoLegal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, textoLegal), {}, {
            className: "textoLegal",
            segment: segment
          })), secondTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, secondTitle), {}, {
            className: "secondTitle",
            segment: segment
          })), (button1 || button2) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "ctaBox",
            children: [button1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, button1), {}, {
              segment: segment,
              className: "button"
            })), button2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, button2), {}, {
              segment: segment,
              className: "button"
            }))]
          }), features && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "productInfoGap_content_features",
            children: features.map(feature => /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, featureStyles), {}, {
              text: feature,
              segment: segment
            })))
          }), (price1 || price2 || button3) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `productInfoGap_content_bottom ${claim && claim.label ? 'withClaim' : ''}`,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "prices_gap",
                children: [claim && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, claim), {}, {
                  borderColor: "transparent",
                  segment: segment
                })), price1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread(_objectSpread({}, price1), {}, {
                  segment: segment
                })), price2 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread(_objectSpread({}, price2), {}, {
                  segment: segment
                }))]
              }), button3 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, _objectSpread(_objectSpread({}, button3), {}, {
                segment: segment
              }))]
            })
          })]
        })
      }), !button1 && !button2 && customLink1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, customLink1), {}, {
        isBlockElement: true,
        className: "absLink"
      }))]
    });
  }

}

ProductItem.propTypes = {
  /**
   * {
   *  "info": "color de fondo",
   *  "kind": "both",
   *  "beautifulName": "bgColor"
   * }
   */
  bgColor: _propTypes.default.oneOf(convertToOptions(BG_COLOR)),

  /**
   * {
   *  "info": "tipo de borde de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "border"
   * }
   */
  border: _propTypes.default.oneOf(convertToOptions(BORDER)),

  /**
   * {
   *  "info": "opciones box shadow de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "boxShadow"
   * }
   */
  boxShadow: _propTypes.default.oneOf(convertToOptions(BOX_SHADOW)),

  /**
   * {
   *  "info": "listado elementos con información",
   *  "kind": "both",
   *  "beautifulName": "features"
   * }
   */
  features: _propTypes.default.array,

  /**
   * {
   *  "info": "color del texto del listado elementos con información",
   *  "kind": "both",
   *  "beautifulName": "featuresColor"
   * }
   */
  featureStyles: _propTypes.default.array,

  /**
   * {
   *  "info": "imagen de la tarjeta",
   *  "kind": "both",
   *  "beautifulName": "img"
   * }
   */
  img: _propTypes.default.string,

  /**
   * {
   *  "info": "imagen logo",
   *  "kind": "both",
   *  "beautifulName": "brandImg"
   * }
   */
  brandImg: _propTypes.default.object,

  /**
   * {
   *  "info": "altura de la caja de información del producto, el caso default está pensdo para tener efecto onMouseEnter",
   *  "kind": "both",
   *  "beautifulName": "productInfoHeight"
   * }
   */
  productInfoHeight: _propTypes.default.oneOf(convertToOptions(PRODUCT_INFO_HEIGHT)),

  /**
   * {
   *  "info": "altura de la imagen del producto",
   *  "kind": "both",
   *  "beautifulName": "pictureGapHeight"
   * }
   */
  pictureGapHeight: _propTypes.default.oneOf(convertToOptions(PICTURE_GAP_HEIGHT)),

  /**
   * {
   *  "info": "altura de la imagen del producto",
   *  "kind": "both",
   *  "beautifulName": "pictureGapHeight"
   * }
   */
  layout: _propTypes.default.oneOf(convertToOptions(CARD_LAYOUT)),

  /**
   * {
   *  "info": "ancho de los productItems",
   *  "kind": "both",
   *  "beautifulName": "ancho"
   * }
   */
  width: _propTypes.default.oneOf(convertToOptions(PRODUCT_INFO_WIDTH)),

  /**
   * {
   *  "info": "componentes, tiene que ser uno del array COMPONENTS. El componente PriceBox es un componente interno de ProductItem",
   *  "kind": "both",
   *  "beautifulName": "components"
   * }
   */
  components: _propTypes.default.shape([COMPONENTS.TEXT_INFO_1 // COMPONENTS.TEXT_INFO_2,
  // COMPONENTS.TEXT_INFO_3,
  // COMPONENTS.CLAIM_1,
  // COMPONENTS.PRICE_1,
  // COMPONENTS.PRICE_2,
  // COMPONENTS.BUTTON_1,
  // COMPONENTS.PRICE_BOX,
  ]).isRequired,

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf(convertToOptions(SEGMENT))
};
ProductItem.defaultProps = {
  bgColor: BG_COLOR.WHITE,
  features: null,
  featureStyles: null,
  img: null,
  brandImg: null,
  border: BORDER.RADIUS,
  boxShadow: BOX_SHADOW.DEFAULT,
  productInfoHeight: PRODUCT_INFO_HEIGHT.DEFAULT,
  pictureGapHeight: PICTURE_GAP_HEIGHT.SHORT,
  layout: CARD_LAYOUT.DEFAULT,
  width: PRODUCT_INFO_WIDTH.DEFAULT,
  segment: SEGMENT.GP
};
var _default = ProductItem;
exports.default = _default;

//# sourceMappingURL=index.js.map